<template>
    <div class="clinicItem">
        <div class="text">
            <div class="area" v-if="item.county">{{ item.county }}．{{ item.district }}</div>
            <a :href="`clinic/${item.slug}`" class="subject-title">
                <div class="title">{{ item.name }}</div>
                <input type="hidden" class="type_id_specId_key" :data-type_id_specId_key="item.typeIdSpecIdKey" name="type_id_specId_key[]" :value="item.typeIdSpecIdKey">
                <img v-if="item.blueTick" src="img/pic/clinic/blueTick.png" alt="肌內效認證">
            </a>
            <div class="description" v-if="item.ClinicField.synopsis" v-html="item.ClinicField.synopsis">
            </div>
            <div class="tagBox" v-if="item.retrieveMaskedTags?.length">
                <div class="tag" v-for="(tag,key) in item.retrieveMaskedTags" :key="key">{{ tag }}</div>
            </div>
            <div class="infoBox">
                <div class="infoLeft">
                    <div class="ratingNumber">
                        <div class="icon"><img src="img/pic/star.png" alt=""></div>
                        <span class="score">{{item.ratingScore}}</span>
                        <span class="count">({{ item.ratingCount }})</span>
                    </div>
                    <div class="cost">
                        <div class="icon"><img src="img/pic/clinic/coin.svg" alt=""></div>
                        <span>
                            {{ item.expense === 0 ? '自費' : '健保' }}
                        </span>
                    </div>
                    <div class="type" v-if="item.ClassMetasIcon">
                        <div class="icon"><img src="img/pic/clinic/man.svg" alt=""></div>
                        <span>{{ item.ClassMetasIcon }}</span>
                    </div>
                    <div class="address">
                        <div class="icon"><img src="img/pic/clinic/map.svg" alt=""></div>
                        <span>{{ item.zipcode }} {{ item.addressText }}</span>
                    </div>
                </div>
                <div class="infoRight">
                    <a :href="`clinic/${ item.slug }`">
                        <div class="checkBtn">查看更多</div>
                    </a>
                </div>
            </div>
        </div>
        <div class="picBox">
            <div class="pic" v-if="item.Pics">
                <a :href="`clinic/${ item.slug }`">
                    <img :src="item?.Pics[0]?.url['w0h0']">
                </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ClinicComponent',
    components: {},
    props: {
        item: {
            type: Object,
            default: () => {},
        },
    },
    mounted() {
    },
    data() {
        return {};
    },
    methods: {},
};
</script>
<style scoped lang="scss">
$maincolor : #72ca4a;
.clinicItem {
    display: flex;
    flex-wrap: wrap;
    padding: 4%;
    &:hover {
        transition: 0.3s;
        background-color: #eee;
    }
    @media (max-width: 768.98px) {
        padding: 2rem 0;
        &:hover {
            background-color: white;
        }
    }
    .text {
        display: flex;
        flex-direction: column;
        width: 50%;
        margin-right: 5%;
        word-wrap: break-word;
        @media (max-width: 1366.98px) {
            margin-right: 3%;
        }
        @media (max-width: 1024.98px) {
            width: 100%;
            margin-right: 0;
            margin-bottom: 20px;
        }
        .area {
            color: $maincolor;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            margin-bottom: 1rem;
        }
        .subject-title{
            display: flex;
            margin-bottom: 1rem;
            .title {
                color: #333;
                font-size: 20px;
                &:hover {
                    transition: 0.3s;
                    color: $maincolor;
                }
            }
            img{
                width: auto;
                height: 16px;
                margin-left: 10px;
                align-self: center;
            }
        }
        .description {
            min-height: 60px;
            color: #777;
            font-size: 14px;
            letter-spacing: 2px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box; //設定為block區塊
            -webkit-line-clamp: 4; //最多只到第x行
            -webkit-box-orient: vertical; //垂直排列
            margin-bottom: 1rem;
            p {
                margin-bottom: 2px;
            }
        }
        .tagBox {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 1rem;
            @media (max-width: 479.98px) {
                width: 100%;
            }
            .tag {
                color: white;
                background-color: $maincolor;
                font-size: 13px;
                padding: 6px 8px;
                margin: 3px 10px 3px 0;
                @media (max-width: 479.98px) {
                    font-size: 12px;
                    padding: 4px 6px;
                }
            }
        }
        .infoBox {
            display: flex;
            @media (max-width: 1366.98px) {
                margin-top: 5px;
            }
            @media (max-width: 1024.98px) {
                margin-top: 15px;
            }
            .infoLeft {
                flex: 1;
                color: #777;
                font-weight: 300;
                .ratingNumber {
                    display: flex;
                    align-items: center;
                    .score {
                        margin-left: 5px;
                    }
                    .count {
                        margin-left: 3px;
                    }
                }
                .ratingNumber,
                .cost,
                .type,
                .address {
                    letter-spacing: 2px;
                    margin-bottom: 3px;
                }
                .icon {
                    display: inline-block;
                    width: 18px;
                    margin-right: 6px;
                }
            }
            .infoRight {
                display: flex;
                align-items: flex-end;
                @media (max-width: 479.98px) {
                    display: none;
                }
                .checkBtn {
                    color: white;
                    background-color: $maincolor;
                    text-align: center;
                    font-size: 14px;
                    border-radius: 6px;
                    padding: 6px 35px;
                    &:hover {
                        background: darken($maincolor, 8%);
                        transition: 0.3s;
                    }
                }
            }
        }
    }
    .picBox {
        width: 40%;
        height: 270px;
        @media (max-width: 1366.98px) {
            width: 47%;
            height: auto;
            display: flex;
            align-items: flex-end;
        }
        @media (max-width: 1024.98px) {
            width: 100%;
            align-items: center;
        }
        .pic {
            position: relative;
            width: 100%;
            height: 100%;
            overflow: hidden;
            @media (max-width: 1024.98px) {
                height: 88%;
            }
            img {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                @media (max-width: 1024.98px) {
                    position: relative;
                }
            }
        }
    }
}
</style>
